import { AxiosError, isAxiosError } from "axios";

function safeStringify(data: unknown): string {
  try {
    return JSON.stringify(data);
  } catch {
    return "[Unserializable data]";
  }
}

function genericErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return `Error: ${error.name}: ${error.message}\nStack:\n${error.stack}`;
  }
  if (typeof error === "string") return `Error: ${error}`;
  if (typeof error === "object" && error !== null)
    return `Error object: ${safeStringify(error)}`;
  return `Unknown error type: ${String(error)}`;
}

function axiosErrorMessage(error: AxiosError): string {
  const { config, response, message } = error;
  return [
    "Axios request failed:",
    `- URL: ${config?.url ?? "unknown"}`,
    `- Method: ${config?.method ?? "unknown"}`,
    `- Status: ${response?.status ?? "unknown"}`,
    `- Status Text: ${response?.statusText ?? "unknown"}`,
    `- Message: ${message}`,
    `- Data: ${safeStringify(response?.data)}`,
  ].join("\n");
}

function formatLog(message?: string, details?: string): string {
  return [message, details].filter(Boolean).join("\n");
}

/**
 * Format an error message for logging.
 *
 * @param error - The error to format.
 * @param customMessage - An optional custom message to include in the log.
 */
export function formatErrorMessage(
  error: unknown,
  customMessage?: string,
): string {
  if (isAxiosError(error)) {
    return formatLog(customMessage, axiosErrorMessage(error));
  }
  return formatLog(customMessage, genericErrorMessage(error));
}
